module.exports = __webpack_public_path__ + "static/laughing-child-1-xh39gk-f13f495478e40036f4ed10fe0b7183c2.jpg";